import { Sanitize } from '../../Sanitize/Sanitize';
import Switch from '../Components/Switch';
import LinkSVG from '../Components/Link.svg'

import { makeText } from '../../../util';
import CookieTable from '../../PrivacyManagerTCFv2/Vendors/CookieTable';
import SimpleAccordion from '../../PrivacyManagerTCFv2/Vendors/SimpleAccordion';

const Tag = ({ vendorName, url, style = {}, tabbable }) => (
  <a style={style} href={url} target="_blank" className="vendor-tag linked">
    <span>{vendorName}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

export const VendorContent = ({
  vendor,
  settings,
  language,
  dev,
  accordionOpen,
  toggleVendor,
  usePurModel,
  hideAppleToggle,
  neutralPm
}) => {
  const cookieText = makeText(Boolean(dev), settings, 'cookieText', language);
  const tableCategoryText = makeText(Boolean(dev), settings, 'tableCategoryText', language);
  const tableCookieText = makeText(Boolean(dev), settings, 'tableCookieText', language);
  const tableDomainText = makeText(Boolean(dev), settings, 'tableDomainText', language);
  const tableDurationText = makeText(Boolean(dev), settings, 'tableDurationText', language);

  // IAB Categories
  const iabConsent = makeText(Boolean(dev), settings, 'iabConsent', language);
  const iabLegInt = makeText(Boolean(dev), settings, 'iabLegInt', language);
  const iabFeatures = makeText(Boolean(dev), settings, 'iabFeatures', language);
  const iabSpecialFeatures = makeText(Boolean(dev), settings, 'iabSpecialFeatures', language);
  const iabSpecialPurposes = makeText(Boolean(dev), settings, 'iabSpecialPurposes', language);
  const purposesTableHeaderText = makeText(Boolean(dev), settings, 'purposesTableHeaderText', language);
  const retentionTableHeaderText = makeText(Boolean(dev), settings, 'retentionTableHeaderText', language);
  const purposeTitleText = makeText(Boolean(dev), settings, 'purposeTitleText', language);
  const privacyPolicyTitleText = makeText(Boolean(dev), settings, 'privacyPolicyTitleText', language);
  const legitIntUrlTitleText = makeText(Boolean(dev), settings, 'legitIntUrlTitleText', language);
  const dataCategoriesTitleText = makeText(Boolean(dev), settings, 'dataCategoriesTitleText', language);

  const consentCatsWithRetention = vendor.consentCategories.some(({ retention }) => retention)
  const liCatsWithRetention = vendor.legIntCategories.some(({ retention }) => retention)
  const specialPurposesWithRetention = !!vendor.iabSpecialPurposesObjs

  return (
    <div className="vendor-content">
      {vendor.description && (
        <p className="pm-sub-p" dangerouslySetInnerHTML={{ __html: Sanitize({ html: vendor.description }) }} />
      )}
      {vendor.cookieHeader && (
        <div className="vendor-cookie-header">{vendor.cookieHeader}</div>
      )}
      <div style={{ flexDirection: 'row', alignItems: 'center' }}>
        <div style={{ marginRight: 5 }}>
          {privacyPolicyTitleText}:
        </div>
        <Tag vendorName={vendor.name} url={vendor.policyUrl} tabbable={accordionOpen} style={{ marginTop: 10 }} />
      </div>
      {vendor.legIntUrl && (
        <div style={{ flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ marginRight: 5 }}>
            {legitIntUrlTitleText}:
          </div>
          <Tag vendorName={vendor.name} url={vendor.legIntUrl} tabbable={accordionOpen} style={{ marginTop: 10 }} />
        </div>
      )}
      <h2>
        {purposeTitleText}
      </h2>
      <div>
        {vendor.consentCategories.length > 0 && (
          <div className="vendor-info">
            {!neutralPm && (
              <div className="vendor-header-container">
                <div className="info-title">{iabConsent}</div>
                <div>
                  <Switch
                    consentType="consent"
                    child="vendors"
                    value={vendor}
                    checked={vendor.active}
                    toggle={toggleVendor}
                    dev={dev}
                    settings={settings}
                    language={language}
                    usePurModel={usePurModel}
                  />
                </div>
              </div>
            )}
            {consentCatsWithRetention
              ? (
                <table
                  style={{ border: '1px solid #00000038', padding: 10, borderRadius: 5, width: '100%' }}
                >
                  <tr>
                    <th style={{ textAlign: 'left' }}>
                      {purposesTableHeaderText}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                      {retentionTableHeaderText}
                    </th>
                  </tr>
                  {vendor.consentCategories.map(c => (
                    <tr>
                      <td>
                        {c.name}
                      </td>
                      <td style={{ textAlign: 'center', minWidth: 100 }}>
                        {c.retention || '-'}
                      </td>
                    </tr>
                  ))}
                </table>
              )
              : (
                <div className="vendor-info">
                  {vendor.consentCategories.map(c => <div>&#8226; {c.name}</div>)}
                </div>
              )}
          </div>
        )}
        {vendor.legIntCategories.length > 0 && (
          <div className="vendor-info">
            <div className="vendor-header-container">
              <div className="info-title">{iabLegInt}</div>
              <div>
                <Switch
                  consentType="legInt"
                  child="vendors"
                  value={vendor}
                  checked={vendor.legInt}
                  toggle={toggleVendor}
                  dev={dev}
                  settings={settings}
                  language={language}
                  locked={hideAppleToggle}
                  usePurModel={usePurModel}
                />
              </div>
            </div>
            {liCatsWithRetention
              ? (
                <table
                  style={{ border: '1px solid #00000038', padding: 10, borderRadius: 5, width: '100%' }}
                >
                  <tr>
                    <th style={{ textAlign: 'left' }}>
                      {purposesTableHeaderText}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                      {retentionTableHeaderText}
                    </th>
                  </tr>
                  {vendor.legIntCategories.map(c => (
                    <tr>
                      <td>
                        {c.name}
                      </td>
                      <td style={{ textAlign: 'center', minWidth: 100 }}>
                        {c.retention || '-'}
                      </td>
                    </tr>
                  ))}
                </table>
              )
              : (
                <div className="vendor-info">
                  {vendor.legIntCategories.map(c => <div>&#8226; {c.name}</div>)}
                </div>
              )}
          </div>
        )}
        {vendor.iabSpecialPurposes.length > 0 && (
          <div className="vendor-info">
            <div className="info-title">{iabSpecialPurposes}</div>
            {specialPurposesWithRetention
              ? (
                <table
                  style={{ border: '1px solid #00000038', padding: 10, borderRadius: 5, width: '100%' }}
                >
                  <tr>
                    <th style={{ textAlign: 'left' }}>
                      {purposesTableHeaderText}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                      {retentionTableHeaderText}
                    </th>
                  </tr>
                  {vendor.iabSpecialPurposesObjs.map(c => (
                    <tr>
                      <td>
                        {c.name}
                      </td>
                      <td style={{ textAlign: 'center', minWidth: 100 }}>
                        {c.retention || '-'}
                      </td>
                    </tr>
                  ))}
                </table>
              )
              : (
                <div className="vendor-info">
                  {vendor.iabSpecialPurposes.map(c => <div>&#8226; {c.name || c}</div>)}
                </div>
              )}
          </div>
        )}
        {vendor.iabFeatures.length > 0 && (
          <div className="vendor-info">
            <div className="info-title">{iabFeatures}</div>
            {vendor.iabFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialFeatures.length > 0 && (
          <div className="vendor-info">
            <div className="info-title">{iabSpecialFeatures}</div>
            {vendor.iabSpecialFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
      </div>
      {(vendor.iabDataCategories && vendor.iabDataCategories.length)
        ? (
          <div>
            <h3>{dataCategoriesTitleText}</h3>
            {vendor.iabDataCategories.map((d, i) => (
              <SimpleAccordion dataCategory={d} first={i === 0} last={i === vendor.iabDataCategories.length - 1} />
            ))}
          </div>
        )
        : null}
      {vendor.cookies.length > 0 && (
        <div className="vendor-cookies">
          <div className="cookie-title">{cookieText}</div>
          <table className="tvtbl">
            <tr>
              <th>{tableCookieText}</th>
              <th>{tableDomainText}</th>
              <th>{tableCategoryText}</th>
              <th>{tableDurationText}</th>
            </tr>
            {vendor.cookies.length > 0 && (
              <CookieTable cookies={vendor.cookies} />
            )}
          </table>
        </div>

      )}
    </div>
  );
};